import React, { createContext, ReactNode, useContext } from 'react';

interface ApolloClientRefreshContextProps {
  recreateApolloClient: () => void;
}

const ApolloClientRefreshContext =
  createContext<ApolloClientRefreshContextProps>({
    recreateApolloClient: () => undefined,
  });

export const ApolloClientRefreshProvider = ({
  children,
  recreateApolloClient,
}: {
  children: ReactNode;
  recreateApolloClient: () => void;
}) => {
  return (
    <ApolloClientRefreshContext.Provider value={{ recreateApolloClient }}>
      {children}
    </ApolloClientRefreshContext.Provider>
  );
};

export const useApolloClientRefresh = () =>
  useContext(ApolloClientRefreshContext);
